import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bulkBar", "count"]
  static values = { batchTriageUrl: String }

  #selected = new Set()

  toggle(event) {
    const id = event.currentTarget.closest("[data-thread-id]").dataset.threadId
    if (this.#selected.has(id)) {
      this.#selected.delete(id)
    } else {
      this.#selected.add(id)
    }
    this.#updateUI()
  }

  async batchTriage(event) {
    if (this.#selected.size === 0) return
    const status = event.params.status
    const ids = [...this.#selected]
    this.#selected.clear()
    this.#updateUI()
    try {
      const response = await fetch(this.batchTriageUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({ thread_ids: ids, status, filter_params: window.location.search.replace(/^\?/, "") })
      })
      if (!response.ok) return
      Turbo.renderStreamMessage(await response.text())
    } catch {
      // optimistic clear already applied
    }
  }

  clearSelection() {
    this.#selected.clear()
    this.#updateUI()
  }

  #updateUI() {
    const n = this.#selected.size
    this.element.querySelectorAll("[data-thread-id]").forEach(card => {
      card.dataset.selected = this.#selected.has(card.dataset.threadId) ? "true" : ""
    })
    this.bulkBarTarget.classList.toggle("hidden", n === 0)
    if (this.hasCountTarget) this.countTarget.textContent = `${n} selected`
  }
}
